import { Component, AfterViewInit, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MdDialog } from '@angular/material';
import { LoginService } from '../../../../services/';
import { Documento } from '../../../../models';

@Component({
  selector: 'qs-detalledocumentos',
  templateUrl: './detalledocumentos.component.html',
})

export class DocumentosDetalleComponent implements OnInit, AfterViewInit {

  public pdfSrc: string;
  public url: any;
  public title: string;
  public document: any;

  constructor(private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef,
    public sanitizer: DomSanitizer) { }

  // tslint:disable-next-line: no-empty
  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.document = this._loginService.transient;
    this.pdfSrc = this.document.url;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.document.url);
    this._changeDetectorRef.detectChanges();
  }

  print(): void {

    window.open(this.pdfSrc).print();
    /* let printContents, popupWin;
    printContents = document.getElementById('pdf').innerHTML;
    printContents = printContents.replace('svg:svg', 'svg');
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
            .svg-container {
              display: inline-block;
              position: relative;
              width: 100%;
              padding-bottom: 100%;
              vertical-align: middle;
              overflow: hidden;
          }
          .svg-content {
              display: inline-block;
              position: absolute;
              top: 0;
              left: 0;
          }
          </style>
        </head>
    <body onload="window.print();window.close()"><div class="container">${printContents}</div></body>
      </html>`
    );
    popupWin.document.close(); */
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/documentos/detalledocumentos/detalledocumentos.component.ts